import stepsImage from '../../assets/images/backgrounds/steps_img-big.png';
import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';

const MANAGER_URL = 'https://t.me/BandaApps_Manager';

export const Steps = ({ t }) => (
  <section className="steps-section">
    <div className="steps-section__inner">
      <Reveal className="steps-section__content">
        <SectionHeading eyebrow={t('steps.eyebrow')} title={t('steps.title')} />
        <ol className="steps-list">
          {t('steps.items').map((item, index) => (
            <li key={item}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <p>{item}</p>
            </li>
          ))}
        </ol>
        <a className="button button--dark" href={MANAGER_URL} target="_blank" rel="noreferrer">
          {t('steps.cta')}
        </a>
      </Reveal>
      <div className="steps-section__image">
        <img src={stepsImage} alt="" />
      </div>
    </div>
  </section>
);
